import { render, staticRenderFns } from "./house-query-bank.vue?vue&type=template&id=ebc19416&scoped=true"
import script from "./house-query-bank.vue?vue&type=script&lang=js"
export * from "./house-query-bank.vue?vue&type=script&lang=js"
import style0 from "./house-query-bank.vue?vue&type=style&index=0&id=ebc19416&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc19416",
  null
  
)

export default component.exports